'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './news-list.routes';

export class NewsListComponent {
  constructor(NewsService, Auth, $state, Config) {
    'ngInject';
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.currentPage = 1;
    this.itemsPerPage = Config.getPaginationWithDefault("news", 5);

    this.NewsService = NewsService;

    Auth.isAdmin(isAdmin => {
      this.isAdmin = isAdmin;
      this.pageTitle = Config.getPageTitleByStateWithDefault($state.current.name, this.type);

      this.news = [];

      this.NewsService.getByTypeLimitResult({type: this.type, count: 25}, data => {
        this.news = data.filter(post => !post.isDraft || (post.isDraft && isAdmin) );

        this.news.forEach(news => {
          news.body = this.convertShortcode(news.body);
        });
      }, err => {
        console.log('Could not retrieve news posts');
      });
    });
  }

  convertShortcode(html) {
    return html.replace(/\[/g,"<").replace(/\]/g,">");
  }
}

export default angular.module('conduuApp.newsList', [uiRouter])
  .config(routes)
  .component('newsList', {
    template: require('./news-list.html'),
    controller: NewsListComponent,
    controllerAs: 'ctrl',
    bindings: {
      type: '@'
    }
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/news/list/news-list.component.js